import React, { useEffect } from 'react';
import { CheckCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type, 
  isVisible, 
  onClose, 
  duration = 3000 
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div className={`
        flex items-center p-4 rounded-lg shadow-lg max-w-md
        ${type === 'success' 
          ? 'bg-green-600 text-white' 
          : 'bg-red-600 text-white'
        }
      `}>
        <div className="flex items-center">
          {type === 'success' ? (
            <CheckCircleIcon className="h-5 w-5 mr-3" />
          ) : (
            <XCircleIcon className="h-5 w-5 mr-3" />
          )}
          <span className="text-sm font-medium">{message}</span>
        </div>
        
        <button
          onClick={onClose}
          className="ml-4 flex-shrink-0 hover:opacity-70 transition-opacity"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast; 